import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/map";
import * as moment from 'moment'
import { UserService } from "../user/user.service";


@Injectable()
export class CommonService {

  weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  userExportPer;
  commonAction = new Subject();
  constructor(public snackBar: MatSnackBar, private userService: UserService) {

  }
  thousandSymbol = this.userService.getLoggedInUser().settings.thousandSymbol;
  decimalSymbol = this.userService.getLoggedInUser().settings.decimalSymbol;

  public openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  //function to check where authentication was successfull
  public isAuthenticated(): boolean {    
    let user = this.getLoggedInUser();
    if (user.ownerId) {
      // logged in so return true
      return true;
    }

    return false;
  }

  //function to get loggedin user
  public getLoggedInUser(): any {
    let user = {
      ownerId: ''
    };
    if (localStorage.getItem("sdsxc")) {
      user = JSON.parse(atob(localStorage.getItem("sdsxc")));
    }
    return user;
  }

  // function to get token
  public getToken(): string {
    let token: string = this.getLoggedInUser().token;
    return token;
  }

  //function to get ownerId
  public getOwnerId(): string {
    let ownerId: string = this.getLoggedInUser().ownerId;
    return ownerId;
  }

  public buildFilter(filterObj) {
    let filterString = "";
    if (filterObj.page) {
      filterString += "page=" + filterObj.page + "&";
    }
    if (filterObj.limit) {
      filterString += "limit=" + filterObj.limit + "&";
    }
    if (filterObj.fileds) {
      filterString += "fileds=" + filterObj.fileds + "&";
    }
    if (filterObj.where) {
      for (let f in filterObj.where) {
        filterString += "where[" + f + "]=" + filterObj.where[f] + "&";
      }
    }
    return filterString;
  }

  public getUTCDate(value: any, args?: any): string {
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    let d = new Date(value);
    if (!d) {
      return "-";
    }
    let u =
      d.getUTCDate() +
      " " +
      months[d.getUTCMonth()] +
      " " +
      d.getUTCFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes() +
      ":" +
      d.getSeconds();


    return u;
  }

  // public convertDate(dateType, fromDate = "", toDate = "" , utc = 1) {
  //   try {
  //     let firstDay = "";
  //     let lastDay = "";

  //     let curr = new Date();
  //     let fDate = new Date();
  //     let lDate = new Date();
  //     let tempF,tempL;
  //     switch (dateType) {
  //       case 'Today':
  //         fDate = new Date(curr.getFullYear() + '/' + (curr.getMonth() + 1) + '/' + curr.getDate() + " 00:00:00");
  //         lDate = new Date(curr.getFullYear() + '/' + (curr.getMonth() + 1) + '/' + curr.getDate() + " 23:59:59");
  //         firstDay = this.getFormattedDate(fDate, dateType);
  //         lastDay = this.getFormattedDate(lDate, dateType, "lastDay");


  //         tempF = moment().startOf('day')
  //         tempL = moment().endOf('day')

  //         break;
  //       case 'Yesterday':
  //         fDate = new Date(curr.getFullYear() + '/' + (curr.getMonth() + 1) + '/' + (curr.getDate()-1) + " 00:00:00");
  //         lDate = new Date(curr.getFullYear() + '/' + (curr.getMonth() + 1) + '/' + (curr.getDate()-1) + " 23:59:59");
  //         firstDay = this.getFormattedDate(fDate, dateType);
  //         lastDay = this.getFormattedDate(lDate, dateType, "lastDay");


  //         tempF = moment().subtract(1,'day').startOf('day')
  //         tempL = moment().subtract(1,'day').endOf('day');

  //         break;
  //       case 'This week':
  //         var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
  //         var last = first + 6; // last day is the first day + 6
  //         fDate = new Date(curr.setDate(curr.getDate() - curr.getDay()));
  //         lDate = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
  //         firstDay = this.getFormattedDate(fDate, dateType);
  //         lastDay = this.getFormattedDate(lDate, dateType, "lastDay");

  //         // tempF = moment().subtract(dayOffSet, subtractType).startOf(subtractType).format(dateFormat);;
  //         tempF = moment().startOf('weeks')
  //         tempL = moment().endOf('weeks')

  //         break;
  //       case 'This month':
  //         fDate = new Date(curr.getFullYear(), curr.getMonth(), 1);
  //         lDate = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
  //         firstDay = this.getFormattedDate(fDate, dateType);
  //         lastDay = this.getFormattedDate(lDate, dateType, "lastDay");


  //         tempF = moment().startOf('month')
  //         tempL = moment().endOf('month')


  //         break;
  //       case 'This year':
  //         fDate = new Date(curr.getFullYear(), 0);
  //         lDate = new Date(curr.getFullYear(), 12, 0);
  //         firstDay = this.getFormattedDate(fDate, dateType);
  //         lastDay = this.getFormattedDate(lDate, dateType, "lastDay");

  //         tempF = moment().startOf('year');
  //         tempL = moment().endOf('year');


  //         break;
  //       case 'Custom':
  //         fDate = new Date(fromDate);
  //         lDate = new Date(toDate);
  //         firstDay = this.getFormattedDate(fDate, dateType);
  //         lastDay = this.getFormattedDate(lDate, dateType, "lastDay");
  //         break;
  //     }

  //     console.log("Old from :" ,firstDay , " Old to: ", lastDay);

  //     if(tempF && tempL)
  //       console.log("New from :" ,tempF.format("YYYY-MM-DD HH:mm:ss") , " Old to: ", tempL.format("YYYY-MM-DD HH:mm:ss"));

  //     if(utc == 1){
  //       firstDay = this.getOffsetConverted(firstDay, "YYYY-MM-DD HH:mm:ss", false);
  //       lastDay = this.getOffsetConverted(lastDay, "YYYY-MM-DD HH:mm:ss", false);
  //       // firstDay = this.getLocalToUTCDate(firstDay);
  //       // lastDay = this.getLocalToUTCDate(lastDay);
  //     }

  //     return { "firstDay": firstDay, "lastDay": lastDay };
  //   }catch(err) {}
  // }

  public isToday(date) {
    let c = moment().startOf('day');
    let sd = moment(date).startOf('day');//selected date
    if (c.date() == sd.date() && c.month() == sd.month()) {
      return true;
    }

    return false;
  }

  public convertDate(dateType, fromDate = "", toDate = "", utc = 1) {
    try {
      let firstDay: any = moment();
      let lastDay: any = moment().endOf('day');

      let curr = new Date();
      let fDate = new Date();
      let lDate = new Date();
      switch (dateType) {

        case 'Yesterday':
          firstDay = moment().subtract(1, 'day').startOf('day')
          lastDay = moment().subtract(1, 'day').endOf('day');
          break;

        case 'Today':
          firstDay = moment().startOf('day');
          lastDay = moment().endOf('day');
          break;

        case 'Last week':
          let _cwtd = this.getWTD(moment().subtract(1, 'weeks').format("YYYY-MM-DD HH:mm:ss"));
          firstDay = moment(_cwtd.from).startOf('day');
          lastDay = moment(_cwtd.from).add(6, 'days').endOf('day');          
          break;

        case 'Last month':
          firstDay = moment().subtract(1, 'month').startOf('month');
          lastDay = moment().subtract(1, 'month').endOf('month');
          break;

        case 'Last year':
          firstDay = moment().subtract(1, 'year').startOf('year');
          lastDay = moment().subtract(1, 'year').endOf('year');
          break;

        case 'This week':
          firstDay = moment().startOf('weeks');
          lastDay = moment().endOf('weeks');
          break;

        case 'This month':
          firstDay = moment().startOf('month');
          lastDay = moment().endOf('month');
          break;

        case 'This year':
          firstDay = moment().startOf('year');
          lastDay = moment().endOf('year');
          break;

        case 'MTD':
          firstDay = moment(toDate).startOf('month');
          lastDay = moment(toDate).endOf('day');
          break;

        case 'YTD':
          firstDay = moment(toDate).startOf('year');
          lastDay = moment(toDate).endOf('day');
          break;

        case 'WTD':
          let mtd = this.getWTD(toDate);
          firstDay = mtd.from;
          lastDay = mtd.to.endOf('day');
          break;

        case 'Trend Date':
          fromDate = this.getDateConverted(fromDate, "YYYY-MM-DD HH:mm:ss");
          firstDay = moment(fromDate).startOf('day');
          lastDay = moment(fromDate).endOf('day');
          break;

        case 'Custom':
          fDate = new Date(fromDate);
          lDate = new Date(toDate);
          firstDay = this.getFormattedDate(fDate, dateType);
          lastDay = this.getFormattedDate(lDate, dateType, "lastDay");
          break;
      }

      //convert Moment date to format datetime format;
      if (dateType != "Custom") {
        firstDay = firstDay.format("YYYY-MM-DD HH:mm:ss");
        lastDay = lastDay.format("YYYY-MM-DD HH:mm:ss");
      }

      if (["YTD", "MTD", "WTD"].includes(dateType) && fromDate != "") {
        lastDay = toDate;
      }

      if (utc == 1) {
        firstDay = this.getDateConverted(firstDay, "YYYY-MM-DD HH:mm:ss");
        lastDay = this.getDateConverted(lastDay, "YYYY-MM-DD HH:mm:ss");
        // firstDay = this.getLocalToUTCDate(firstDay);
        // lastDay = this.getLocalToUTCDate(lastDay);
      }
      return { "firstDay": firstDay, "lastDay": lastDay };
    } catch (err) { }
  }

  getFormattedDate(date, dateType, dayType = "") {
    if (dateType == 'Today') {
      date = date.getFullYear() + '-' + this.addZero(date.getMonth() + 1) + '-' + this.addZero(date.getDate()) + ' ' + this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':' + this.addZero(date.getSeconds());
      return date;
    }
    if (dayType == "lastDay") {
      date = [date.getFullYear(), this.addZero(date.getMonth() + 1), this.addZero(date.getDate())].join('-');
      return date + " 23:59:59";
    } else {
      date = [date.getFullYear(), this.addZero(date.getMonth() + 1), this.addZero(date.getDate())].join('-');
      return date + " 00:00:00";
    }
  }

  getFutureDate(from, to, type = "") {
    if (type == "past") {
      from = from.getFullYear() + '-' + this.addZero(from.getMonth() + 1) + '-' + this.addZero(from.getDate()) + ' ' + this.addZero(from.getHours()) + ':' + this.addZero(from.getMinutes()) + ':' + '00';
      to = to.getFullYear() + '-' + this.addZero(to.getMonth() + 1) + '-' + this.addZero(to.getDate()) + ' ' + this.addZero(to.getHours()) + ':' + this.addZero(to.getMinutes()) + ':' + '59';
      return { "firstDay": from, "lastDay": to };
    }else{
      from = [from.getFullYear(), this.addZero(from.getMonth() + 1), this.addZero(from.getDate())].join('-');
      return { "firstDay": (from + " 00:00:00"), "lastDay": "" }
    }
  }

  addZero(date) {
    return (date < 10) ? "0" + date : date;
  }

  getWTD(frmD): any {
    let mTD = {};
    if (frmD) {
      let sett = this.getUserSetting();
      let sw = sett.startOfWeek ? sett.startOfWeek : 0;
      let startWeekI = parseInt(sw);
      startWeekI = startWeekI || 1;    //this condition start of week Monday related added by ravi
      //Math.floor(Math.random() * 7);
      let selectedDay = moment(frmD).format('ddd');
      let diff = this.weekDays.indexOf(selectedDay) - startWeekI;
      let fromDSW = moment(frmD).startOf('week');
      if (diff > 0) {
        mTD["from"] = moment(fromDSW).add(startWeekI, 'day');
        mTD["to"] = moment(frmD).endOf('day');
      }
      else if (diff < 0) {
        let ystrW = moment(fromDSW).subtract(1, 'week').startOf('week');
        mTD["from"] = ystrW.add(startWeekI, 'days');
        mTD["to"] = moment(frmD).endOf('day');
      }
      else {
        mTD["from"] = moment(frmD).startOf('day');
        mTD["to"] = moment(frmD).endOf('day');
      }
    }
    return mTD;
  }

  public getLocalToUTCDate(value: any, args?: any): string {
    value = Date.parse(value);
    let d = new Date(value);
    if (!d) {
      return "-";
    }
    let u =
      d.getUTCFullYear() +
      "-" +
      this.addZero(d.getUTCMonth() + 1) +
      "-" +
      this.addZero(d.getUTCDate()) +
      " " +
      this.addZero(d.getUTCHours()) +
      ":" +
      this.addZero(d.getUTCMinutes()) +
      ":" +
      this.addZero(d.getUTCSeconds());

    return u;
  }

  public getUTCToLocalDate(value: any, isFormatted = 0, args?: any): string {
    let d = new Date(value + ' UTC');
    if (!d) {
      return "-";
    }
    if (isFormatted) {
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      if (!d) {
        return "-";
      }
      let u =
        d.getDate() +
        " " +
        months[d.getMonth()] +
        " " +
        d.getFullYear();

      return u;
    }
    let u =
      d.getFullYear() +
      "-" +
      this.addZero(d.getMonth() + 1) +
      "-" +
      this.addZero(d.getDate()) +
      " " +
      this.addZero(d.getHours()) +
      ":" +
      this.addZero(d.getMinutes()) +
      ":" +
      this.addZero(d.getSeconds());

    return u;
  }

  shortNumberFormat(val = 0) {
    if (!val) {
      val = 0;
    }
    // n = 100000; d = 0;
    // let x, p;
    // x = ('' + n).length, p = Math.pow, d = p(10, d)
    // x -= x % 3
    // console.log(Math.round(n * d / p(10, x)) / d + " kMGTPE"[x / 3]);
    // return Math.round(n * d / p(10, x)) / d + " kMGTPE"[x / 3];.
    let cVal = "" + val;
    if (val > 0) {
      if (val >= 1000000000) { cVal = (val / 1000000000).toFixed(2) + 'B'; }
      else if (val >= 1000000) { cVal = (val / 1000000).toFixed(2) + 'M'; }
      else if (val >= 1000) { cVal = (val / 1000).toFixed(2) + 'K'; }
      else { cVal = (val).toFixed(0) }
    } else {
      if (val <= -1000000000) { cVal = (val / 1000000000).toFixed(2) + 'B'; }
      else if (val <= -1000000) { cVal = (val / 1000000).toFixed(2) + 'M'; }
      else if (val <= -1000) { cVal = (val / 1000).toFixed(2) + 'K'; }
      else { cVal = (val).toFixed(0) }
    }

    let v = cVal.split(".");
    if (v[1] == "00B" || v[1] == "00M" || v[1] == "00K") {
      cVal = v[0] + v[1].replace("00", "");
    }
    return cVal;
  }

  getMDYDate(date) {
    return this.addZero(date.getDate()) + "-" + this.addZero(date.getMonth() + 1) + "-" + date.getFullYear()
  }

  getHMDate(date) {
    return this.addZero(date.getHours()) + ":" + this.addZero(date.getMinutes());
  }


  imageToDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  getAction(): Observable<any> {
    return this.commonAction.asObservable();
  }

  sendAction(action, data) {
    this.commonAction.next({ action: action, data: data });
  }

  getLocalTimeOffSet() {
    let localTimezone;
    let tz = new Date().getTimezoneOffset();
    let tzh = Math.abs(Math.round(new Date().getTimezoneOffset() / 60));
    let tzm = Math.abs(new Date().getTimezoneOffset() % 60);
    if (tz > 0) {
      localTimezone = "-" + this.addZero(tzh) + ":" + this.addZero(tzm);
    } else {
      localTimezone = "+" + this.addZero(tzh) + ":" + this.addZero(tzm);
    }
    return localTimezone;
  }

  getOffsetConverted(dateTime, dateFormat = "YYYY-MM-DD HH:mm:ss", isAdd = true) {
    let val;
    let offsetV = this.userService.getOffsetValueFromSetting(isAdd);
    val = moment(dateTime).utcOffset(offsetV).format(dateFormat);
    return val;
  }

  getOffsetConvertedSite(dateTime, dateFormat = "YYYY-MM-DD HH:mm:ss", isAdd = true) {
    let val;
    val = moment(dateTime).format(dateFormat);
    return val;
  }

  getDateConverted(dateTime, dateFormat = "YYYY-MM-DD HH:mm:ss") {
    let val = moment(dateTime).format(dateFormat);
    return val;
  }

  getUserSetting() {
    //get User ExportPermission
    let userP = this.userService.getLoggedInUser();
    return userP.settings;
  }

  getWeekNumber(dateTime, dateTimeFormat = "YYYY-MM-DD HH:mm:ss"): number {
    return moment(dateTime, dateTimeFormat).week();
  }

  parseToDbDateStartOfTheDay(date) {
    let _dt = new Date(moment.utc(date, "YYYY-MM-DD 00:01:00").toISOString());
    // return new Date(_dt.getFullYear(), _dt.getMonth(), _dt.getDate(), 0, 1, 0, 0);    
    return [_dt.getFullYear(), this.addZero(_dt.getMonth() + 1), this.addZero(_dt.getDate())].join('-') + " 00:00:01";
  }


  parseToDbDateEndOfTheDay(date) {
    let _dt = new Date(moment.utc(date, "YYYY-MM-DD 23:59:00").toISOString());
    // return new Date(_dt.getFullYear(), _dt.getMonth(), _dt.getDate(), 23, 59, 0, 0);
    return [_dt.getFullYear(), this.addZero(_dt.getMonth() + 1), this.addZero(_dt.getDate())].join('-') + " 23:59:00";
  };

  inFuture(date) {
    return new Date(date).getTime() > new Date().getTime()
  }

  insertWidgetData(dbCon, _widget) {
    if(dbCon.objectStoreNames.length > 0){
      const txn = dbCon.transaction('widgets', 'readwrite');
      const store = txn.objectStore('widgets');
      store.put(_widget);
    }
  }

  connectIdxDB = () => {
    let _user = this.userService.getLoggedInUser();
    return new Promise((resolve: any, reject: any) => {
      const req = window.indexedDB.open(_user._id, 1);
      req.onsuccess = (ev: any) => {
        resolve(ev.target.result);
      }
      req.onupgradeneeded = (event: any) => {
        let store = event.target.result.createObjectStore('widgets', {
          keyPath: 'widgetId'
        });
        resolve(event.target.result);
      }
      req.onerror = (e) => {
        reject(e);
      }
    });
  }

  readIdWidget = (dbCon, key) => {
    return new Promise((resolve, reject) => {
      try {
        var trx = dbCon.transaction('widgets').objectStore('widgets');
        let query = trx.get(key);
        query.onsuccess = (r) => {
          if (r.target.result === undefined) {
            resolve(undefined);
          } else {
            resolve(r.target.result);
          }
        }
        query.onerror = (e) => {
          reject(e);
        }
      } catch (ex) {
        resolve(undefined);
      }
    });
  }

  deleteIdxWidgetData(dbCon, key) {
    var trx = dbCon.transaction('widgets', 'readwrite').objectStore('widgets');
    if (key.constructor.name == "Array") {
      key.forEach(_k => {
        trx.delete(_k);
      });
    }
    else {
      trx.delete(key);
    }
  }

  deleteIdxWidgetDataOnLogout(uid) {
    const req = window.indexedDB.open(uid, 1);
    req.onsuccess = (ev: any) => {
      let dbCon = ev.target.result;
      var trx = dbCon.transaction('widgets', 'readwrite').objectStore('widgets');
      trx.getAll().onsuccess = function (event) {
        const nonCustom = event.target.result.filter(i => i.isCustomRange == false);
        nonCustom.forEach(_widgetStore => {
          trx.delete(_widgetStore.widgetId);
        });
      };
    }
  }

  formatNumberString(value, type = false) {
    value = value.toString();
    if (type) {
      var lstChr = '';
      if (value.includes("K") || value.includes("M") || value.includes("B")) {
        lstChr = value.charAt(value.length - 1);
        value = Number(value.replace(lstChr, ''));
      }
      // value = Number(value);
      // return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1" + ts).replace('.', ds) + lstChr;
      return value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1" + this.thousandSymbol).replace('.', this.decimalSymbol) + lstChr;
    }
    else
      return value.replace('.', this.decimalSymbol);
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/common/common.service.ts